import { ReactNode } from 'react';
import * as Toastify from 'react-toastify';
import styled from 'styled-components';

import CloseButton from './CloseButton';

interface ToastProps extends Toastify.ToastContentProps {
  readonly children: ReactNode;
}

export default function Toast(props: ToastProps) {
  const { closeToast, children } = props;

  return (
    <Container data-testid="paradex-toast">
      {children}
      <CloseButton onClick={closeToast} />
    </Container>
  );
}

const Container = styled.div`
  width: 320px;
  position: relative;
`;
